import { VercelProduct as Product } from 'lib/bigcommerce/types';
import './shipping-restriction.css';

export function ShippingRestriction({ product }: { product: Product }) {
  return (
    <>
      {product.productMetafields.map((field: any, i) => (
        field.key === 'shipping-restrictions' 
          ? <div className={`shipping-restriction-text`} dangerouslySetInnerHTML={{ __html: field.value }} key={i} />
          : null
      ))}
    </>
  );
}
